import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import Gratitudes from 'features/gratitudes';

const Page = () => (
  
  <MainLayout>
    <Gratitudes />
  </MainLayout>
);

export default Page;
